<template>
  <div>
    <div class="air__utils__heading">
      <h5>Prijstabellen</h5>
    </div>
    <div class="row">
      <div class="col-xl-12 col-lg-6">
        <div class="card">
          <div class="card-body">
            <price-table />
          </div>
        </div>

      </div>
      <div class="col-xl-4 col-lg-6">

      </div>
    </div>
  </div>
</template>
<script>
import PriceTable from '@/components/widgets/PriceTable/PriceTable'
// import moment from 'moment'
export default {
  components: {
    PriceTable,
  },
}
</script>
